import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";

// A–Z glossary of every option on the page with its category · group tag.
export function TiqGlossary({ page, onOpen }) {
  const [q, setQ] = useState("");
  const all = useMemo(() => {
    const out = [];
    (page.categories || []).forEach((category) => (category.groups || []).forEach((group) => (group.options || []).forEach((option) => { if (!option.is_draft) out.push({ category, group, option }); })));
    return out.sort((a, b) => a.option.name.localeCompare(b.option.name));
  }, [page]);
  const needle = q.trim().toLowerCase();
  const shown = needle ? all.filter(({ option }) => `${option.name} ${option.definition}`.toLowerCase().includes(needle)) : all;
  return (
    <section className="max-w-[1200px] mx-auto px-5 lg:px-10 py-12" data-testid="tiq-glossary">
      <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.4em] text-[var(--org-accent)] font-bold">Glossary</div>
          <h2 className="font-heading text-3xl sm:text-4xl uppercase tracking-tight text-white mt-1">Every term, A–Z</h2>
          <div className="text-[12px] text-[#a0a0a0] mt-1">{all.length} terms in the system, in one place.</div>
        </div>
        <label className="relative w-full sm:w-72">
          <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-[#757575]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter glossary…" className="w-full bg-[#101010] border border-white/15 text-white text-sm pl-9 pr-3 py-2.5 focus:outline-none focus:border-[var(--org-accent)]" data-testid="tiq-glossary-search" />
        </label>
      </div>
      <div className="columns-1 md:columns-2 xl:columns-3 gap-x-10">
        {shown.map(({ category, group, option }) => (
          <button key={option.id} onClick={() => onOpen(category.id, option.id)} className="block w-full text-left break-inside-avoid border-b border-white/10 py-3.5 hover:bg-white/[0.02]" style={{ transition: "background-color .15s" }} data-testid={`tiq-gloss-${option.id}`}>
            <div className="flex items-baseline gap-2 flex-wrap">
              <span className="font-heading text-lg uppercase tracking-wide text-white">{option.name}</span>
              <span className="text-[9px] uppercase tracking-[0.2em] font-bold" style={{ color: category.color }}>{category.is_coverage ? `vs ${category.name}` : `${category.name} · ${group.title}`}{option.parent_name ? ` · ${option.parent_name}` : ""}</span>
            </div>
            <div className="text-[13px] text-[#a0a0a0] leading-relaxed mt-0.5">{option.definition}</div>
          </button>
        ))}
        {shown.length === 0 && <div className="text-sm italic text-[#757575] py-6">No terms match.</div>}
      </div>
    </section>
  );
}
